<template>
    <div>
        <form name="change-address-form" @submit.prevent="submitChangeAddress()">
            <ls-modal
                :options="modals.changeAddress"
                :disable-content-scroll="true"
                @onModalClose="closeModal(modalName)"
            >
                <div slot="header">
                    <h3 class="ls-align--center ls-color--green">
                        Update your address below to get a fast &amp; accurate quote
                    </h3>
                </div>

                <div class="grid">
                    <div class="grid__col-12">
                        <div class="change-address__input-container">
                            <ls-google-autocomplete
                                ref="googleAutocomplete"
                                v-model="address.googlePlace.formatted_address"
                                google-autocomplete-label="Your Address"
                            ></ls-google-autocomplete>
                        </div>
                    </div>
                </div>

                <div slot="button" class="grid">
                    <div class="grid__col-12">
                        <div>
                            <div slot="button" class="ls-float-right">
                                <button
                                    class="ls-button ls-button--white"
                                    type="button"
                                    @click="closeModal(modalName)"
                                >
                                    Cancel
                                </button>
                                <button
                                    slot="button"
                                    v-ls-track.click="{
                                        target: 'change-address-modal--submit-button',
                                    }"
                                    class="ls-button ls-button--blue"
                                >
                                    Update Address
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ls-modal>
        </form>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import lsModal from '@/components/original-mydot/modals/modal/Modal.vue';
import lsGoogleAutocomplete from '@/components/original-mydot/google-components/GoogleAutocomplete.vue';

export default {
    components: {
        lsModal,
        lsGoogleAutocomplete,
    },
    data() {
        return {
            modalName: 'changeAddress',
        };
    },
    computed: {
        ...mapState(['modals', 'address', 'loading', 'order']),
    },
    methods: {
        ...mapActions({
            closeModal: types.MODAL__CLOSE_MODAL,
            orderCreateQuote: types.ORDER__CREATE_QUOTE,
        }),
        submitChangeAddress() {
            this.$refs.googleAutocomplete.validateAddress();
            setTimeout(() => {
                if (!this.$refs.googleAutocomplete.isValid || this.loading.quotingOrder) {
                    return;
                }

                this.orderCreateQuote({
                    changingAddress: true,
                    type: this.order.intent,
                });
                this.closeModal(this.modalName);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.change-address__input-container {
    margin-bottom: rem(3);

    @include min-screen(breakpoint(sm)) {
        padding: rem(3) rem(6);
    }
}
</style>
